<aside class="filters">
  <div class="filters__header">
    <h3>{{ 'filters.title' | transloco }}</h3>
    <button class="btn btn--text btn--sm" (click)="clearAllFilters()">{{ 'filters.clearAll' | transloco }}</button>
  </div>

  <app-filter-cards
    [filterCards]="filterCards"
    [salaryPeriods]="salaryPeriods"
    [salaryFilter]="salaryFilter"
    [loading]="loading"
    (filterSelected)="onFilterSelected($event)"
    (salaryFilterChanged)="onSalaryFilterChanged($event)">
  </app-filter-cards>
</aside>
